/// When `true`, products will be displayed as "coming soon". The product-pages will feature
/// some text explaining, that this product is "under construction" instead of offering
/// the products for purchase.
const settingShopComingSoon = true

exports.settingShopComingSoon = settingShopComingSoon
